import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  .board-extra-container {
    display: flex;
  }
`;
export const PopupContainer = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  height: auto;
  position: relative;
  .create-board {
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    width: 80%;
    margin: 1rem auto;
    border-radius: 24px;
    padding: 1rem;
    .create-board_header {
      width: 100%;
    }
    .create-routine_form_container {
      width: 100%;
      .form-group {
        display: flex;
        flex-direction: column;
        label {
          font-size: 25px;
          font-weight: 700;
          color: #a8aeb2;
        }
        input {
          font-size: 25px;
          font-weight: 700;
          color: #000;
          border: none;
          border-bottom: 1px solid black;
        }
      }
      .button-container {
        display: flex;
        justify-content: flex-end;
        padding: 1rem 0;
        button {
          border: none;
          font-size: 16px;
          color: blue;
          background: transparent;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .name-error {
        display: none;
        color: red;
        font-weight: 700;
        &.active {
          display: block;
        }
      }
      .extra_options-container {
        display: none;
        &.active {
          display: block;
        }
      }
      .frequency-container {
        display: flex;
        width: 100%;
        justify-content: space-between;
        border-bottom: 1px solid black;
        .frequency_day-container {
          display: flex;
          width: 14%;
          text-align: center;
          flex-direction: column;
          align-items: center;
          .routine-frequency-input {
            border: none;
            width: 50%;
            height: 35px;
            margin: 1rem 0;
            background: linear-gradient(
              35deg,
              #fa7c30 50%,
              rgba(0, 0, 0, 0) 50%
            );
            &.active {
              background: #fa7c30;
            }
          }
        }
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .create-board {
      width: 50%;
    }
  }
`;

export const ToolbarWindow = styled.div`
  width: 63px;
  height: 90vh;
  background: rgb(235, 237, 238);
  z-index: 5;
  box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
  position: fixed;
  margin-top: 10vh;
  overflow: scroll;
`;
export const TopbarWindow = styled.div`
  width: 100%;
  height: 10vh;
  display: flex;
  background: #fff;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
  z-index: 10;
  position: fixed;
`;

export const DropBoard = styled.div`
  width: calc(100% - 63px);
  min-height: calc(90vh + 500px);
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10vh;
  margin-left: 63px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .board {
    width: calc(100% + 500px);
    height: calc(100% + 500px);
    min-width: 100vw;
    min-height: 100vh;
    overflow: auto;
    padding: 10px;
    text-align: center;
    min-height: 100px;
    background-color: #f4f4f4;
    position: relative;
    box-sizing: border-box;
    margin: -50px 0 0 -50px;
    touch-action: pan-x pan-y;
  }
`;

export const Tool = styled.div`
  padding: 0.5rem 0;
  margin: 5px;
  background-color: #cce7ff;
  height: 8%;
  user-select: none;
  cursor: move;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 24px;
    height: 24px;
    margin-bottom: 5px;
    pointer-events: none;
  }
  span {
    font-size: 9px;
    text-align: center;
  }
  &.draggingActive {
    box-shadow: 0 11px 15px -7px rgba(51, 61, 78, 0.2),
      0 9px 46px 8px rgba(51, 61, 78, 0.12),
      0 24px 38px 3px rgba(51, 61, 78, 0.14);
  }
  @media only screen and (min-width: 867px) {
    height: fit-content;
  }
`;
